import { initTranslation } from './translations/i18n'
import { isSignInEntry } from './sign-in/routing'

const show = (path) => window.location.pathname.startsWith(path)

const load = (promise) =>
    promise
        .then((p) => p.default())
        .catch((err) => {
            console.error('[split] Failed to load module:', err)
        })

const start = async () => {
    await initTranslation()

    if (show('/bekreft/')) load(import('./confirm'))
    else if (show('/mail-connection-result')) load(import('./mail-connection-result'))
    else if (show('/letter')) load(import('./letter'))
    else if (show('/document')) load(import('./docView'))
    else if (show('/rettemelding')) load(import('./corrections2'))
    // The new sign-in, and the IdP callbacks it started; every other URL keeps the legacy login in ./client.
    else if (isSignInEntry(window.location)) load(import('./sign-in'))
    else load(import('./client'))
}

start()

/*
import React from "react";
import ReactDOM from "react-dom";
import App from './app'


const start = () => {

  const container = document.getElementById("maincontent");
  ReactDOM.render(
    <App />,
    container
  );

}

start()
*/
